﻿import React, {FC} from 'react';
import {SortFilterContainer} from "../../common/reports/sortFilter/SortFilterContainer";
import {DateFormats} from "../../constants/securspace-constants";
import moment, {Moment} from "moment";
import {SortFilterItemContainer} from "../../common/reports/sortFilter/SortFilterItemContainer";
import {LocationNameAutocomplete} from "../../location/LocationNameAutocomplete";
import {AutocompleteChangeReason} from "@mui/material";
import DatePicker from '../../common/inputs/DatePicker/DatePicker';
import type {SortValuesType} from './SupplierActivitySummarySortInput';
import {SupplierActivitySummarySortInput} from "./SupplierActivitySummarySortInput";
import {SortDirType} from "../../../types/common/SortDirType";
import {SortFilterRowContainer} from "../../common/reports/sortFilter/SortFilterRowContainer";

interface SupplierActivitySummarySortFilterProps {
  sort: SortValuesType;
  onSortChange: (sort: SortValuesType) => void;
  sortDir: SortDirType;
  onSortDirChange: (sortDir: SortDirType) => void;
  locationId: string;
  onLocationChangeId: (locationId: string) => void;
  date: string;
  onDateChange: (date: string) => void;
}

const SupplierActivitySummarySortFilter: FC<SupplierActivitySummarySortFilterProps> = ({ sort, onSortChange, sortDir, onSortDirChange, locationId, onLocationChangeId, date, onDateChange }) => {

  const handleLocationNameChange = (_event: any, newValue: any, reason: AutocompleteChangeReason) => {
    if (reason !== 'createOption') {
      onLocationChangeId(newValue.id)
    }
  }

  const handleDateChange = (event: Moment | null) => {
    onDateChange(moment(event).format(DateFormats.DAY).toString());
  }

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <LocationNameAutocomplete value={locationId} onChange={handleLocationNameChange} />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <DatePicker
          value={date}
          onChange={handleDateChange}
          label={'Date'}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <SupplierActivitySummarySortInput sort={sort}
                                          sortDir={sortDir}
                                          onSortChange={onSortChange}
                                          onSortDirChange={onSortDirChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { SupplierActivitySummarySortFilter };
